"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var utils_1 = require("../../core/utils");

var RealImpactValue_1 = require("../../release/model/RealImpactValue");

var RealImpactValueConverter_1 = require("./RealImpactValueConverter");

var RealImpactValueConverterImpl =
/*#__PURE__*/
function (_RealImpactValueConve) {
  _inherits(RealImpactValueConverterImpl, _RealImpactValueConve);

  function RealImpactValueConverterImpl() {
    _classCallCheck(this, RealImpactValueConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(RealImpactValueConverterImpl).apply(this, arguments));
  }

  _createClass(RealImpactValueConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new RealImpactValue_1.RealImpactValue(RealImpactValue_1.RealImpactValue.schema.salesVolumeImpact.valueOf(conversions.toBigNumber(source.salesVolumeImpact)), RealImpactValue_1.RealImpactValue.schema.bm.valueOf(conversions.toBigNumber(source.bm)), RealImpactValue_1.RealImpactValue.schema.bmPercent.valueOf(conversions.toBigNumber(source.bmPercent)), RealImpactValue_1.RealImpactValue.schema.bmImpact.valueOf(conversions.toBigNumber(source.bmImpact)), RealImpactValue_1.RealImpactValue.schema.bmImpactInPercent.valueOf(conversions.toBigNumber(source.bmImpactInPercent)), RealImpactValue_1.RealImpactValue.schema.profit.valueOf(conversions.toBigNumber(source.profit)), RealImpactValue_1.RealImpactValue.schema.profitPercent.valueOf(conversions.toBigNumber(source.profitPercent)), RealImpactValue_1.RealImpactValue.schema.profitImpact.valueOf(conversions.toBigNumber(source.profitImpact)), RealImpactValue_1.RealImpactValue.schema.profitImpactInPercent.valueOf(conversions.toBigNumber(source.profitImpactInPercent)), RealImpactValue_1.RealImpactValue.schema.revenueImpact.valueOf(conversions.toBigNumber(source.revenueImpact)), RealImpactValue_1.RealImpactValue.schema.estimationInPercent.valueOf(conversions.toBigNumber(source.estimationInPercent)), RealImpactValue_1.RealImpactValue.schema.forecast.valueOf(conversions.toBigNumber(source.forecast)), RealImpactValue_1.RealImpactValue.schema.forecastObsolete.valueOfField(source), RealImpactValue_1.RealImpactValue.schema.expectedRevenue.valueOf(conversions.toBigNumber(source.expectedRevenue)), RealImpactValue_1.RealImpactValue.schema.amount.valueOf(conversions.toBigNumber(source.amount)), RealImpactValue_1.RealImpactValue.schema.saleValueWithVat.valueOf(conversions.toBigNumber(source.saleValueWithVat)), !utils_1.Utils.isValueMissing(source.saleValueWithoutVat) ? RealImpactValue_1.RealImpactValue.schema.saleValueWithoutVat.valueOf(conversions.toBigNumber(source.saleValueWithoutVat)) : PriceFormulas_1.PriceFormulas.ZERO, RealImpactValue_1.RealImpactValue.schema.costValue.valueOf(conversions.toBigNumber(source.costValue)), RealImpactValue_1.RealImpactValue.schema.diffDays.valueOfField(source));
    }
  }, {
    key: "documentToObject",
    value: function documentToObject(conversions) {
      var _this = this;

      return function (doc) {
        return _this.toObject(doc, conversions);
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        salesVolumeImpact: conversions.fromBigNumber(source.salesVolumeImpact),
        bm: conversions.fromBigNumber(source.bm),
        bmPercent: conversions.fromBigNumber(source.bmPercent),
        bmImpact: conversions.fromBigNumber(source.bmImpact),
        bmImpactInPercent: conversions.fromBigNumber(source.bmImpactInPercent),
        profit: conversions.fromBigNumber(source.profit),
        profitPercent: conversions.fromBigNumber(source.profitPercent),
        profitImpact: conversions.fromBigNumber(source.profitImpact),
        profitImpactInPercent: conversions.fromBigNumber(source.profitImpactInPercent),
        revenueImpact: conversions.fromBigNumber(source.revenueImpact),
        estimationInPercent: conversions.fromBigNumber(source.estimationInPercent),
        forecast: conversions.fromBigNumber(source.forecast),
        forecastObsolete: source.forecastObsolete,
        expectedRevenue: conversions.fromBigNumber(source.expectedRevenue),
        amount: conversions.fromBigNumber(source.amount),
        saleValueWithVat: conversions.fromBigNumber(source.saleValueWithVat),
        saleValueWithoutVat: conversions.fromBigNumber(source.saleValueWithoutVat),
        costValue: conversions.fromBigNumber(source.costValue),
        diffDays: source.diffDays
      });
      return result;
    }
  }]);

  return RealImpactValueConverterImpl;
}(RealImpactValueConverter_1.RealImpactValueConverter);

exports.RealImpactValueConverterImpl = RealImpactValueConverterImpl;